/**
 * =============================================================================
 * SCRIPT-NAME:   App.js
 * PROJEKT:       Freiseinapp - Haupt-Router
 * VERSION:       v1.i24
 * DATUM:         2026-06-14
 * AENDERUNGEN v1.i24:
 * - SOS Toolkit komplett entfernt (Player, Import, Route /sos-toolkit) – Toolkit lebt jetzt ausschließlich unter gewissenapp.de
 * =============================================================================
 */

import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useState } from "react";
import Login from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import AdminDashboard from "./components/AdminDashboard";
import Contacts from "./components/Contacts";
import Conversions from "./components/Conversions";
import ClientDashboard from "./components/ClientDashboard";
import ClientCoaching from "./components/ClientCoaching";
import TestDashboard from "./components/TestDashboard";
import Register from "./components/Register";
import SetPassword from "./components/SetPassword";
import AdminFreischaltung from "./components/AdminFreischaltung";
import AnalyticsDashboard from "./components/AnalyticsDashboard";
import SendEmail from "./components/SendEmail";
import SpeedTest from "./components/SpeedTest";
import KdiTracker from "./components/kdi_tracker";

// --- IMPORTE FUER DAS ADS-MANAGEMENT ---
import AdsKeywordManager from "./components/AdsKeywordManager";
import AdsPerfDashboard from "./components/AdsPerfDashboard";
import GadsKpi from "./components/GadsKpi";
import GadsExport from "./components/GadsExport";
import Redaktionsplan from "./components/Redaktionsplan";

// --- IMPORTE FUER DAS GSC KPI-DASHBOARD ---
import GscKpi from "./components/gsc_kpi";
import GscWochenbericht from './components/gsc_wochenbericht';
import GscStatus from "./components/gsc_status";
import SeitenPruefung from "./components/seiten_pruefung";

function App() {
  // eslint-disable-next-line no-unused-vars
  const [token, setToken] = useState(localStorage.getItem("token") || "");
  // eslint-disable-next-line no-unused-vars
  const [role, setRole] = useState(localStorage.getItem("role") || "");

  const ProtectedRoute = ({ element, allowedRoles }) => {
    const currentToken = localStorage.getItem("token");
    const currentRole  = localStorage.getItem("role");
    if (!currentToken || !allowedRoles.includes(currentRole)) {
      return <Navigate to="/" replace />;
    }
    return element;
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login setRole={setRole} setToken={setToken} />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/neu-anmelden" element={<Register />} />
        <Route path="/set-password" element={<SetPassword />} />

        <Route path="/admin" element={<ProtectedRoute element={<AdminDashboard />} allowedRoles={["admin"]} />} />
        <Route path="/contacts" element={<ProtectedRoute element={<Contacts />} allowedRoles={["admin"]} />} />
        <Route path="/conversions" element={<ProtectedRoute element={<Conversions />} allowedRoles={["admin"]} />} />
        <Route path="/admin-freischaltung" element={<ProtectedRoute element={<AdminFreischaltung />} allowedRoles={["admin"]} />} />
        <Route path="/analytics" element={<ProtectedRoute element={<AnalyticsDashboard />} allowedRoles={["admin"]} />} />
        <Route path="/send-email" element={<ProtectedRoute element={<SendEmail />} allowedRoles={["admin"]} />} />
        <Route path="/speed-test" element={<ProtectedRoute element={<SpeedTest />} allowedRoles={["admin"]} />} />
        <Route path="/kdi-tracker" element={<ProtectedRoute element={<KdiTracker />} allowedRoles={["admin"]} />} />

        {/* ADS MANAGEMENT */}
        <Route path="/ads-keywords" element={<ProtectedRoute element={<AdsKeywordManager />} allowedRoles={["admin"]} />} />
        <Route path="/ads-perf"     element={<ProtectedRoute element={<AdsPerfDashboard />}  allowedRoles={["admin"]} />} />
        <Route path="/gads-kpi"     element={<ProtectedRoute element={<GadsKpi />}           allowedRoles={["admin"]} />} />
        <Route path="/gads-export"  element={<ProtectedRoute element={<GadsExport />}        allowedRoles={["admin"]} />} />
        <Route path="/redaktionsplan"   element={<ProtectedRoute element={<Redaktionsplan />}  allowedRoles={["admin"]} />} />

        {/* GSC KPI-DASHBOARD */}
        <Route path="/gsc-kpi"      element={<ProtectedRoute element={<GscKpi />}            allowedRoles={["admin"]} />} />
        <Route path="/gsc-status"   element={<ProtectedRoute element={<GscStatus />}         allowedRoles={["admin"]} />} />
        <Route path="/seiten-pruefung" element={<ProtectedRoute element={<SeitenPruefung />} allowedRoles={["admin"]} />} />
        <Route path="/gsc-wochenbericht" element={<ProtectedRoute element={<GscWochenbericht />} allowedRoles={["admin"]} />} />

        <Route path="/client-dashboard" element={<ProtectedRoute element={<ClientDashboard />} allowedRoles={["client", "admin"]} />} />
        <Route path="/client-coaching" element={<ProtectedRoute element={<ClientCoaching useClientAPI={true} />} allowedRoles={["client", "admin"]} />} />
        <Route path="/client-coaching/:tabellenname" element={<ProtectedRoute element={<ClientCoaching useClientAPI={true} />} allowedRoles={["client", "admin"]} />} />
        <Route path="/test-dashboard" element={<ProtectedRoute element={<TestDashboard />} allowedRoles={["test", "admin"]} />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;